export default {
	ALL: 'ALL',
	HOST: 'HOST',
	GUEST: 'GUEST',
	NOT_LOGGED: 'NOT_LOGGED'
};
